import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function ContextMenu({ x, y, options, onClose }) {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return createPortal(
    <div
      ref={menuRef}
      className="fixed rounded-lg shadow-xl py-1 z-50 min-w-[180px] border"
      style={{
        left: `${x}px`,
        top: `${y}px`,
        backgroundColor: 'var(--color-bg-elevated)',
        borderColor: 'var(--color-border-default)'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {options.map((option, index) => {
        if (option.divider) {
          return <div key={index} className="h-px my-1" style={{ backgroundColor: 'var(--color-border-default)' }} />;
        }

        return (
          <button
            key={index}
            onClick={() => {
              option.onClick();
              onClose();
            }}
            className="w-full px-4 py-2 text-left text-sm transition-colors duration-150 flex items-center space-x-2"
            style={{
              color: option.danger ? '#ef4444' : 'var(--color-text-primary)',
              backgroundColor: 'transparent'
            }}
            onMouseEnter={(e) => {
              if (option.danger) {
                e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.1)';
                e.currentTarget.style.color = '#f87171';
              } else {
                e.currentTarget.style.backgroundColor = 'var(--color-bg-secondary)';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = option.danger ? '#ef4444' : 'var(--color-text-primary)';
            }}
          >
            {option.icon && (
              <span style={{ color: option.danger ? '#ef4444' : 'var(--color-text-muted)' }}>
                {option.icon}
              </span>
            )}
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>,
    document.body
  );
}
